"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const deviceMapped = {
    touch3: {
        iOS: "web_ios",
        AndroidOS: "web_android"
    },
    ios2: {
        iOS: "iOS",
        AndroidOS: "Android"
    },
    tvg4: {
        iOS: "desktop",
        AndroidOS: "desktop"
    },
    fdrmobile: {
        iOS: "web_ios",
        AndroidOS: "web_android"
    },
    fdrios: {
        iOS: "iOS",
        AndroidOS: "Android"
    },
    fdrandroid: {
        iOS: "iOS",
        AndroidOS: "Android"
    },
    androidwrapper: {
        iOS: "iOS",
        AndroidOS: "Android"
    }
};
exports.default = (os, product) => (0, lodash_1.get)(deviceMapped, `${product}.${os}`, "web_ios");



// WEBPACK FOOTER //
// ./node_modules/@tvg/conf/cjs/src/brazeDevice.js